/** Default reducer that just returns it's state unchanged. */
export const defaultReducer = (state: any = {}) => state;
